import { render, staticRenderFns } from "./agency_order.vue?vue&type=template&id=f4f8a7fa&scoped=true"
import script from "./agency_order.vue?vue&type=script&lang=js"
export * from "./agency_order.vue?vue&type=script&lang=js"
import style0 from "./agency_order.vue?vue&type=style&index=0&id=f4f8a7fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8a7fa",
  null
  
)

export default component.exports